import { type DatabaseSdkContract } from '@databases/sdk';
import { type TableV2DataSource } from '@databases/view-layout-table-v2/data';

/**
 * Translates the SDK's field/entry methods into the small read interface used by
 * V2. Keeping this translation here lets the renderer and view session accept
 * sources without importing the SDK or looking up application services.
 *
 * Creating the adapter reads nothing and installs no listeners. The view session
 * later captures IDs/fields and reads individual entries through these methods;
 * SDK ownership and permission checks remain with their existing owners.
 */
export function createTableV2DataSourceFromSdk(sdk: {
  readonly fields: Pick<DatabaseSdkContract['fields'], 'list' | 'getDefaultValue'>;
  readonly values: Pick<DatabaseSdkContract['values'], 'get'>;
  readonly entries: Pick<DatabaseSdkContract['entries'], 'listIds' | 'get'>;
}): TableV2DataSource {
  return {
    listFields: () => sdk.fields.list(),
    listEntryIds: () => sdk.entries.listIds(),
    getEntry: (entryId) => sdk.entries.get(entryId),
    getDefaultValue: (fieldId) => sdk.fields.getDefaultValue(fieldId),
    getValue: (address) => sdk.values.get(address),
  };
}
